import React from 'react';

import { gql } from '@apollo/client';
import { FCWithFragments } from '@modernloop/shared/components';

import { CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2Fragment } from 'src/generated/mloop-graphql';

import SelfScheduleRequestedAlert from '../SelfSchedule/SelfScheduleRequestedAlert';

import {
  CandidateAvailabilityOptionsModal,
  Props as CandidateAvailabilityOptionsModalProps,
} from './CandidateAvailabilityOptionsModal';

type Fragments = {
  jobStageSettingsV2: CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2Fragment | undefined;
};

/**
 * Wrapper component for CandidateAvailabilityOptionsModal.
 *
 * This wrapper is used to conditionally render the SelfScheduleRequestedAlert component
 * if the `isSelfScheduleRequested` prop is true. Otherwise, it renders the
 * CandidateAvailabilityOptionsModal component with the provided props.
 *
 * This approach allows us to handle different UI states (self-schedule requested vs.
 * regular availability options) within a single component, improving code maintainability
 * and readability.
 */
const CandidateAvailabilityOptionsModalWrapper: FCWithFragments<
  Fragments,
  CandidateAvailabilityOptionsModalProps & {
    isSelfScheduleRequested?: boolean;
  }
> = (props) => {
  const { isSelfScheduleRequested, onClose } = props;

  if (isSelfScheduleRequested) {
    return <SelfScheduleRequestedAlert onClose={onClose} />;
  }

  return <CandidateAvailabilityOptionsModal {...props} />;
};

// creating new fragment here because the child component is built in a way that it's not easy to use fragment
// so passing data as props
CandidateAvailabilityOptionsModalWrapper.fragments = {
  jobStageSettingsV2: gql`
    ${CandidateAvailabilityOptionsModal.fragments.jobStageSettingsV2}
    fragment CandidateAvailabilityOptionsModalWrapper_jobStageSettingsV2 on JobStageSettingsV2 {
      id
      ...CandidateAvailabilityOptionsModal_jobStageSettingsV2
    }
  `,
};

export default CandidateAvailabilityOptionsModalWrapper;
